<template>
  <div id="modal__login">
    <BModal :open="openModal" centered
            :no-close-on-backdrop="p_options.login.prevent_close || p_options.login.prevent_close_backdrop"
            @hide="closeModal">
      <LoginModalContent v-if="openModal"
                         @closeModal="closeModal">
      </LoginModalContent>

    </BModal>
  </div>
</template>

<script setup lang="ts">

import {obtainActiveLocale} from "#imports";
import {computed, onMounted, watch, ref, resolveComponent} from "vue";
import {useState} from "#app";
import BModal from "~/components/web/parts/b-modal.vue";

const props = defineProps({
  options: Object
})

const LoginModalContent = resolveComponent("LazyPartsLoginModalContent");


const modalContentLoaded = ref(false);
const p_options = ref({login: {prevent_close: false, prevent_close_backdrop: true, redirect_on_close: false}});


const openModal = computed(() => {
  return useState('login-modal', () => false).value === true;
})

if (props.options) {
  p_options.value = {...p_options.value, ...props.options};
}

const closeModal = () => {
  if (p_options.value.login.redirect_on_close) {
    modalContentLoaded.value = false;
    window.location.href = '/' + obtainActiveLocale().code;
  } else {
    useState('login-modal').value = false;
    useState('login-modal-callbacks', () => []).value = [];
  }
}


</script>
